// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1SNvo","header":"ClearentDisclaimer_header__i3-B8","inner":"ClearentDisclaimer_inner__3pbel"};